import type { AdProductUpgrade } from 'src/graphql/generated';
import type AppState from 'src/types/appState';

export const getPriceAndTaxSelector =
  ({ price }: AdProductUpgrade) =>
  ({
    session: {
      hirerAccount: { hidePrice },
    },
  }: AppState) => {
    if (!hidePrice && price.__typename === 'Price') {
      return price;
    }
    return undefined;
  };
